import { render, staticRenderFns } from "./ListarUsuariosPage.vue?vue&type=template&id=0ff971f8&scoped=true"
import script from "./ListarUsuariosPage.vue?vue&type=script&lang=js"
export * from "./ListarUsuariosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff971f8",
  null
  
)

export default component.exports